import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { BrowserRouter as Router } from 'react-router-dom';
import RouteComponent from './containers/RouteComponent';
import store from './store'; 
import Review from "./components/Review";

export const LanguageContext = React.createContext('somali');

const renderApp = Component => {
    if(localStorage.getItem('modalstatus') == undefined){
            ReactDOM.render(
                <Provider store={store}>
                    <Router>
                        <Component />
                    </Router>
                </Provider>,
            document.getElementById('root')
        );
    }else{
        if(localStorage.getItem('rejectedstatus') != undefined)
        {
            ReactDOM.render(
                <Provider store={store}>
                    
                        <Review />
    
                </Provider>,
            document.getElementById('root')
            );
        }
    }
};
renderApp(RouteComponent);
